import Header from "../menu/Header";
import PageIntro from "../homepage/desktop_components/intro_section/IntroSection";
import { TopSectionsPictures } from "../../enums/images";
import { PrivateEventsTexts } from "../../enums/page_texts/private_events_texts";
import Footer from "../footer/Footer";
import PrivateEventsSection from "./PrivateEventsSection";
import StaticFooter from "../footer/StaticFooter";
import { useQuery } from "@tanstack/react-query";
import { loadPrivateEventsPageData } from "../../services/api";
import LoadingSpinner from "../general/LoadingSpinner";
import SeoHelmet from "../general/SeoHelmet";
import ApiErrorScreen from "../general/ApiErrorScreen";
import BreadcrumbSchema from "../general/BreadcrumbSchema";

function PrivateEventsPage() {
  const { isLoading, isError, refetch } = useQuery({
    queryKey: ["private-events-page"],
    queryFn: async () => {
      await loadPrivateEventsPageData();
      return true;
    },
  });

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <ApiErrorScreen onRetry={() => refetch()} />;
  }

  return (
    <div>
      <SeoHelmet
        title="DJ Mayday | DJ pour événements privés à Liège & Wallonie"
        description="Mariages, anniversaires, soirées d'entreprise à Liège, Ouffet et en Wallonie — DJ Mayday assure une animation musicale professionnelle pour vos événements privés."
        url="https://www.djmayday.com/private-events"
      />
      <BreadcrumbSchema
        items={[
          { name: "Accueil", url: "https://www.djmayday.com/" },
          { name: "Événements privés", url: "https://www.djmayday.com/private-events" },
        ]}
      />
      <h1 style={{ position: 'absolute', width: '1px', height: '1px', padding: 0, margin: '-1px', overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }}>
        DJ pour événements privés à Liège, Ouffet et en Wallonie — Mariages, Anniversaires, Entreprises | DJ Mayday
      </h1>
      <Header />
      <PageIntro
        title={PrivateEventsTexts.Title}
        description={PrivateEventsTexts.DescriptionText}
        backgroundImage={TopSectionsPictures.PrivateEventsPage}
        modalText={PrivateEventsTexts.ModalText}
        aboutModal={PrivateEventsTexts.AboutModal}
        closeModal={PrivateEventsTexts.CloseModal}
        buttonText={PrivateEventsTexts.ButtonText}
      />
      <PrivateEventsSection />
      <StaticFooter />
      <Footer />
    </div>
  );
}

export default PrivateEventsPage;
